export default "./dist/stdassets/images/icons/control-stop-180.png";